/* eslint-disable no-restricted-globals */
/* eslint-disable react-hooks/exhaustive-deps */

import { Flex, Text, VStack } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { gql, useLazyQuery } from '@apollo/client';
import useStore from '../../../store';

const Q_GET_REQUEST = gql`
	query getNpStatistic {
		getNpStatistic
	}
`;

function Statistic() {
	const { currentUser: user } = useStore((state) => state?.currentUser);
	const { currentLang: lang } = useStore((state) => state?.currentLang);
	const [canView, setCanView] = useState(false);
	const [fetchData, { data }] = useLazyQuery(Q_GET_REQUEST);

	useEffect(fetchData, []);

	useEffect(() => {
		if (user) {
			const roles = user?.role.split(',') || [];
			setCanView(roles?.includes('admin'));
		}
	}, [user]);

	return (
		<>
			{canView && data?.getNpStatistic && (
				<Flex pt={4} pb={4}>
					<VStack width="100%" p={4} borderWidth={2} borderStyle="dotted" borderColor="blue.500">
						<Text fontSize="md" fontWeight="600" color="blue.500" width="100%">
							{lang === 'kh' ? 'ចំនួនកំណត់បង្ហាញរឿង/របាយការណ៍ទាំងអស់៖' : 'Number Of All Note Of Presentation/Report:'}
						</Text>
						<Text fontSize="sm" fontWeight="400" color="blue.500" width="100%">
							{lang === 'kh' ? '១) សេចក្តីព្រៀង៖' : '1. Draft:'}&nbsp;
							<span style={{ fontWeight: 700 }}>{data?.getNpStatistic?.draft || 0}</span>
						</Text>
						<Text fontSize="sm" fontWeight="400" color="blue.500" width="100%">
							{lang === 'kh' ? '២) ការិយាល័យ៖' : '2. Office:'}&nbsp;
							<span style={{ fontWeight: 700 }}>{data?.getNpStatistic?.office || 0}</span>
						</Text>
						<Text fontSize="sm" fontWeight="400" color="blue.500" width="100%">
							{lang === 'kh' ? '៣) នាយកដ្ឋាន៖' : '3. Department:'}&nbsp;
							<span style={{ fontWeight: 700 }}>{data?.getNpStatistic?.department || 0}</span>
						</Text>
						<Text fontSize="sm" fontWeight="400" color="blue.500" width="100%">
							{lang === 'kh' ? '៤) អគ្គនាយករង៖' : '4. Deputy Director General:'}&nbsp;
							<span style={{ fontWeight: 700 }}>{data?.getNpStatistic?.ddg || 0}</span>
						</Text>
						<Text fontSize="sm" fontWeight="400" color="blue.500" width="100%">
							{lang === 'kh' ? '៥) អគ្គនាយក៖' : '5. Director General:'}&nbsp;
							<span style={{ fontWeight: 700 }}>{data?.getNpStatistic?.dg || 0}</span>
						</Text>
						<Text fontSize="sm" fontWeight="400" color="blue.500" width="100%">
							{lang === 'kh' ? '៦) អ.ស.ហ.៖' : '6. FSA:'}&nbsp;<span style={{ fontWeight: 700 }}>{data?.getNpStatistic?.fsa || 0}</span>
						</Text>
						<Text fontSize="sm" fontWeight="400" color="blue.500" width="100%">
							{lang === 'kh' ? '៧) សម្រេច៖' : '7. Done:'}&nbsp;<span style={{ fontWeight: 700 }}>{data?.getNpStatistic?.done || 0}</span>
						</Text>
						<Text fontSize="md" fontWeight="600" color="blue.500" width="100%">
							{lang === 'kh' ? 'សរុប៖' : 'Total:'}&nbsp;<span style={{ fontWeight: 700 }}>{data?.getNpStatistic?.total || 0}</span>
						</Text>
					</VStack>
				</Flex>
			)}
		</>
	);
}

export default Statistic;
